import React, { useState, memo } from 'react';
import { Section } from './ui/Section';
import { ChevronDown, ChevronUp } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
export function FAQSection() {
  const faqs = [{
    q: '¿Qué programas necesito para editar?',
    a: '¡Ninguno! Recibirás un enlace para editar directamente en tu navegador web usando Canva (es gratis y muy fácil de usar). No necesitas descargar fuentes ni instalar software.'
  }, {
    q: '¿Cuándo recibiré mis archivos?',
    a: 'El acceso es inmediato. Tan pronto como se confirme tu pago, recibirás un correo electrónico con el enlace de acceso a todos tus diseños y bonos.'
  }, {
    q: '¿Puedo cambiar los colores y las imágenes?',
    a: '¡Sí! Puedes cambiar los textos, fuentes, colores e incluso agregar tus propias fotos si lo deseas. El diseño base está listo, pero tienes control total.'
  }, {
    q: '¿Qué tipo de papel recomiendan para imprimir?',
    a: 'Recomendamos papel opalina o cartulina de 200g a 250g para la mayoría de los elementos (cajitas, banderines). Para las etiquetas de botellas, papel adhesivo resistente al agua.'
  }, {
    q: '¿Puedo imprimir en un centro de copiado?',
    a: '¡Por supuesto! Puedes descargar tus diseños terminados en formato PDF para impresión y llevarlos en una memoria USB o enviarlos por correo a tu centro de copiado local (Office Depot, Lumen, etc).'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <Section className="bg-mint" data-id="element-71">
      {/* Decorative top border */}
      <div className="absolute top-0 left-0 w-full overflow-hidden leading-none z-0 rotate-180" data-id="element-72">
        <svg className="relative block w-full h-[30px]" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1200 120" preserveAspectRatio="none" data-id="element-73">
          <path d="M321.39,56.44c58-10.79,114.16-30.13,172-41.86,82.39-16.72,168.19-17.73,250.45-.39C823.78,31,906.67,72,985.66,92.83c70.05,18.48,146.53,26.09,214.34,3V0H0V27.35A600.21,600.21,0,0,0,321.39,56.44Z" className="fill-white" data-id="element-74"></path>
        </svg>
      </div>

      <div className="text-center mb-12 relative z-10 pt-8" data-id="element-75">
        <h2 className="text-4xl md:text-6xl font-script text-partyPink-hot mb-2" data-id="element-76">
          Nuestras preguntas
        </h2>
        <h3 className="text-3xl md:text-4xl font-black text-white uppercase tracking-wider" data-id="element-77">
          frecuentes y temáticas
        </h3>
      </div>

      <div className="max-w-3xl mx-auto relative z-10" data-id="element-78">
        <div className="space-y-4" data-id="element-79">
          {faqs.map((faq, index) => <div key={index} className="bg-white rounded-2xl overflow-hidden shadow-sm border-2 border-transparent hover:border-mint-dark transition-colors" data-id="element-80">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full px-6 py-4 text-left flex justify-between items-center focus:outline-none" data-id="element-81">
                <span className="font-bold text-gray-800 pr-4" data-id="element-82">{faq.q}</span>
                {openIndex === index ? <ChevronUp className="w-5 h-5 text-partyPink-hot flex-shrink-0" data-id="element-83" /> : <ChevronDown className="w-5 h-5 text-mint-dark flex-shrink-0" data-id="element-84" />}
              </button>

              <AnimatePresence data-id="element-85">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-86">
                    <div className="px-6 pb-4 text-gray-600 font-medium border-t border-gray-100 pt-4" data-id="element-87">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </Section>;
}